import { useSearchParams } from 'react-router-dom';
import StaffPersonnelView from './StaffPersonnelView';
import RolesPermissionsView from './RolesPermissionsView';
import EntitiesView from '../entities/EntitiesView';
import RoleTagsView from './RoleTagsView';
import RouteGuard from '../shared/RouteGuard';

const TABS = [{ key: 'people', label: 'People' }, { key: 'access', label: 'App Access' }, { key: 'structure', label: 'Structure' }];

export default function StaffRolesView({ userId, theme, onEntitiesChanged }) {
    const [params, setParams] = useSearchParams();
    const tab = TABS.some((item) => item.key === params.get('tab')) ? params.get('tab') : 'people';
    // G8: Events Settings links here with ?area=events to show only the Events column of the role presets.
    const areaFilter = tab === 'access' && params.get('area') === 'events' ? 'events' : '';
    return <div>
        <div role="tablist" aria-label="Staff & Roles" className="mb-5 flex gap-3">
            {TABS.map((item) => <button key={item.key} role="tab" id={`staff-tab-${item.key}`}
                aria-selected={tab === item.key} aria-controls={`staff-panel-${item.key}`}
                className={`rounded-full border px-4 py-2 ${tab === item.key ? 'border-[var(--selected-pill-border)] text-[var(--selected-pill-ink)]' : 'border-[var(--surface-border)]'}`}
                onClick={() => setParams({ tab: item.key })}>{item.label}</button>)}
        </div>
        <div role="tabpanel" id={`staff-panel-${tab}`} aria-labelledby={`staff-tab-${tab}`}>
            {tab === 'people' && <RouteGuard module="personnel" action="view"><StaffPersonnelView userId={userId} theme={theme} /></RouteGuard>}
            {tab === 'access' && areaFilter && (
                <p className="mb-4 text-sm" data-testid="area-filter-note">
                    Showing the <strong>Events</strong> area only.{' '}
                    <button type="button" className="underline" onClick={() => setParams({ tab: 'access' })}>Show all areas</button>
                </p>
            )}
            {tab === 'access' && <RolesPermissionsView userId={userId} theme={theme} areaFilter={areaFilter} />}
            {tab === 'structure' && <><EntitiesView mode="departments" userId={userId} theme={theme} onEntitiesChanged={onEntitiesChanged} /><RoleTagsView /></>}
        </div>
    </div>;
}
